<template>
    <v-card flat>
        <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
              <v-row class="no-gutters">
                <v-col cols="12" sm="6" md="9" lg="10">
                    <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search here ..." single-line solo
                        hide-details></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2">
                    <ul>
                        <li>
                            <span>Master:</span>
                            <span>{{managerInvestorOrderHistories?.masterClosedOrders || 0}}</span>
                        </li>

                        <li>
                            <span>Sub-Order:</span>
                           <span>{{managerInvestorOrderHistories?.investorClosedOrders || 0}}</span>
                        </li>
                    </ul>
                </v-col>
            </v-row>
            <v-row class="mt-3">
                <v-col cols="12" sm="12">
                    <v-card
                        class="pa-3 rounded-0 elevation-0"
                        :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'"
                    >
                        <v-sheet
                            class="transactionTable liveTradeTable walletTable pb-3"
                            :color="
                                $vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'
                            "
                        >
                            <v-data-table
                                :headers="headers"
                                :items="managerInvestorOrderHistories?.finalResults"
                                :search="search"
                                :items-per-page="6"
                                :single-expand="true"
                                :item-key="'manager_order'"
                                :expanded.sync="expanded"
                                show-expand
                            >
                                <template v-slot:item.orderno="{ item }">
                                    <span>
                                        {{ item?.ManagerOrderNo }}
                                    </span>
                                </template>
                                <template v-slot:item.Order="{ item }">
                                    <v-icon
                                        small
                                        color="#FF567F"
                                        class="mr-1 align-start"
                                        >mdi-star-outline</v-icon
                                    >
                                    Manager
                                </template>
                                <template v-slot:item.Action="{ item }">
                                    <span
                                        :class="
                                            Number(item.Action) === 1 &&
                                            'profit-text-color'
                                        "
                                    >
                                        {{
                                            Number(item.Action) === 1
                                                ? "Sell"
                                                : "Buy"
                                        }}
                                    </span>
                                </template>
                                <template v-slot:item.Lot="{ item }">
                                    <span class="profit-text-color">
                                        {{ item?.Lot / 10000 }}
                                    </span>
                                </template>
                                <template v-slot:item.Profit="{ item }">
                                    <span>
                                        {{ item?.Profit.toFixed(2) }}
                                    </span>
                                </template>
                                <template v-slot:item.Price="{ item }">
                                    <span>
                                        {{ item?.Price.toFixed(2) }}
                                    </span>
                                </template>
                                <template v-slot:item.VolumeClosed="{ item }">
                                    <span
                                        :style="
                                            item?.VolumeClosed === 0
                                                ? 'color:#16BB93'
                                                : 'color:red'
                                        "
                                    >
                                        {{
                                            item?.VolumeClosed === 0
                                                ? "Open"
                                                : "Closed"
                                        }}
                                    </span>
                                </template>
                                <template
                                    v-slot:expanded-item="{ headers, item }"
                                >
                                    <td :colspan="headers.length" class="pa-0">
                                        <v-data-table
                                            :headers="headers"
                                            :items="item?.investorsOrders"
                                            hide-default-footer
                                            hide-default-header
                                            class="childTable mx-0"
                                        >
                                            <template
                                                v-slot:item.Order="{ item }"
                                            >
                                                <v-icon
                                                    small
                                                    color="#D19909"
                                                    class="mr-1 align-start"
                                                    >mdi-arrow-right-bottom</v-icon
                                                >
                                                Sub-Order
                                            </template>
                                            <template
                                                v-slot:item.Action="{ item }"
                                            >
                                                <span
                                                    :class="
                                                        item?.Action === 1 &&
                                                        'profit-text-color'
                                                    "
                                                >
                                                    {{
                                                        item?.Action === 0
                                                            ? "Buy"
                                                            : item?.Action === 1
                                                            ? "Sell"
                                                            : null
                                                    }}
                                                </span>
                                            </template>
                                            <template
                                                v-slot:item.orderno="{ item }"
                                            >
                                                <span>
                                                    {{ item?.investorOrderNo }}
                                                </span>
                                            </template>
                                            <template
                                                v-slot:item.Lot="{ item }"
                                            >
                                                <span class="profit-text-color">
                                                    {{ item?.Lot / 10000 }}
                                                </span>
                                            </template>
                                            <template
                                                v-slot:item.VolumeClosed="{
                                                    item,
                                                }"
                                            >
                                                <span
                                                    :style="
                                                        item?.VolumeClosed === 0
                                                            ? 'color:#16BB93'
                                                            : 'color:red'
                                                    "
                                                >
                                                    {{
                                                        item?.VolumeClosed === 0
                                                            ? "Open"
                                                            : "Closed"
                                                    }}
                                                </span>
                                            </template>
                                            <template
                                                v-slot:item.Price="{ item }"
                                            >
                                                <span>
                                                    {{ item?.Price.toFixed(2) }}
                                                </span>
                                            </template>
                                        </v-data-table>
                                    </td>
                                </template>
                            </v-data-table>
                        </v-sheet>
                    </v-card>
                </v-col>
            </v-row>
        </v-card>
    </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { MAM__ACTIONS } from "@/store/action-types";

export default {
    data() {
        return {
            search: "",
            expanded: [],
            singleExpand: false,
            headers: [
                { text: "Order", value: "Order" },
                {
                    text: "Order No",
                    value: "orderno",
                },
                { text: "Type", value: "Action" },
                { text: "Login", value: "Login" },
                { text: "Symbol", value: "Symbol" },
                { text: "Lots", value: "Lot" },
                { text: "Price($)", value: "Price" },
                { text: "Profit($)", value: "Profit" },
                { text: "Deal", value: "VolumeClosed" },
                { text: "Status", value: "data-table-expand" },
            ],
        };
    },

    computed: {
        ...mapState("mam", ["managerInvestorOrderHistories"]),
    },

    methods: {
        ...mapActions("mam", [MAM__ACTIONS.ORDERHISTORYMANAGERINVESTORS]),
    },

    async mounted() {
        await this[MAM__ACTIONS.ORDERHISTORYMANAGERINVESTORS](
            this.$route.query.id
        );
    },
};
</script>
